// extracted by mini-css-extract-plugin
module.exports = {"lightAlert":"LrvAlert_lightAlert__fqlxe","darkAlert":"LrvAlert_darkAlert__320Q8"};